import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-pl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-pl.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { DatePipe } from "@angular/common";
import { PropertyAndLeaseService } from "../../../../../shared/services/modules/property-and-lease.service";
import { ViewApplicationDetailsPlConstants } from "./view-application-details-pl.constants";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AlertType } from "../../../../../shared/models/alert";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let ViewApplicationDetailsPlComponent = class ViewApplicationDetailsPlComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    recipientListService;
    recipientSelectService;
    appController;
    datePipe;
    viewApplicationService;
    propertyAndLeaseService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsPlConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    descriptionFormControlName = ViewApplicationDetailsPlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsPlConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    leaseTypeFormControlName = ViewApplicationDetailsPlConstants.LEASE_TYPE_FORM_CONTROL_NAME;
    leaseReasonFormControlName = ViewApplicationDetailsPlConstants.LEASE_REASON_FORM_CONTROL_NAME;
    leaseUseFormControlName = ViewApplicationDetailsPlConstants.LEASE_USE_FORM_CONTROL_NAME;
    leaseRentalAgreementFormControlName = ViewApplicationDetailsPlConstants.LEASE_RENTAL_AGREEMENT_FORM_CONTROL_NAME;
    leaseStartDateFormControlName = ViewApplicationDetailsPlConstants.LEASE_START_DATE_FORM_CONTROL_NAME;
    leaseEndDateFormControlName = ViewApplicationDetailsPlConstants.LEASE_END_DATE_FORM_CONTROL_NAME;
    leaseContractNumberFormControlName = ViewApplicationDetailsPlConstants.LEASE_CONTRACT_NUMBER_FORM_CONTROL_NAME;
    leaseAccountNumberFormControlName = ViewApplicationDetailsPlConstants.LEASE_ACCOUNT_NUMBER_FORM_CONTROL_NAME;
    leaseCommentsFormControlName = ViewApplicationDetailsPlConstants.LEASE_COMMENTS_FORM_CONTROL_NAME;
    leaseContractEscalationFormControlName = ViewApplicationDetailsPlConstants.LEASE_CONTRACT_ESCALATION_FORM_CONTROL_NAME;
    leasePeriodFormControlName = ViewApplicationDetailsPlConstants.LEASE_PERIOD_FORM_CONTROL_NAME;
    leaseNoticePeriodFormControlName = ViewApplicationDetailsPlConstants.LEASE_NOTICE_PERIOD_DATE_FORM_CONTROL_NAME;
    leaseStatusAccordingToCouncilResolutionFormControlName = ViewApplicationDetailsPlConstants.LEASE_STATUS_ACCORDING_TO_COUNCIL_FORM_CONTROL_NAME;
    lesseeTypeFormControlName = ViewApplicationDetailsPlConstants.LESSEE_TYPE_FORM_CONTROL_NAME;
    lesseeFormControlName = ViewApplicationDetailsPlConstants.LESSEE_FORM_CONTROL_NAME;
    saleAmountFormControlName = ViewApplicationDetailsPlConstants.SALE_AMOUNT_FORM_CONTROL_NAME;
    dateofDeedTransferFormControlName = ViewApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME;
    evaluationAmountFormControlName = ViewApplicationDetailsPlConstants.EVALUATION_AMOUNT_FORM_CONTROL_NAME;
    buyerFormControlName = ViewApplicationDetailsPlConstants.BUYER_FORM_CONTROL_NAME;
    sellerFormControlName = ViewApplicationDetailsPlConstants.SELLER_FORM_CONTROL_NAME;
    saleAmountAlienationFormControlName = ViewApplicationDetailsPlConstants.SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    dateofDeedAlienationTransferFormControlName = ViewApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME;
    evaluationAmountAlienationFormControlName = ViewApplicationDetailsPlConstants.EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsPlConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsPlConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsPlConstants.APPLICATION_TYPE_LABEL;
    leaseLabel = ViewApplicationDetailsPlConstants.LEASE_LABEL;
    drawPolygonLabel = ViewApplicationDetailsPlConstants.DRAW_POLYGON_LABEL;
    polygonDrawnLabel = ViewApplicationDetailsPlConstants.POLYGON_DRAWN_LABEL;
    leaseTypeLabel = ViewApplicationDetailsPlConstants.LEASE_TYPE_LABEL;
    leaseReasonLabel = ViewApplicationDetailsPlConstants.LEASE_REASON_LABEL;
    leaseUseLabel = ViewApplicationDetailsPlConstants.LEASE_USE_LABEL;
    leaseRentalAgreementLabel = ViewApplicationDetailsPlConstants.LEASE_RENTAL_AGREEMENT_LABEL;
    leaseStartDateLabel = ViewApplicationDetailsPlConstants.LEASE_START_DATE_LABEL;
    leaseEndDateLabel = ViewApplicationDetailsPlConstants.LEASE_END_DATE_FORM_LABEL;
    leaseContractNumberLabel = ViewApplicationDetailsPlConstants.LEASE_CONTRACT_NUMBER_LabeL;
    leaseAccountNumberLabel = ViewApplicationDetailsPlConstants.LEASE_ACCOUNT_NUMBER_LabeL;
    leaseCommentsLabel = ViewApplicationDetailsPlConstants.LEASE_COMMENTS_LabeL;
    leaseContractEscalationLabel = ViewApplicationDetailsPlConstants.LEASE_CONTRACT_ESCALLATION_LabeL;
    leasePeriodLabel = ViewApplicationDetailsPlConstants.LEASE_PERIOD_LabeL;
    leaseNoticePeriodLabel = ViewApplicationDetailsPlConstants.LEASE_NOTICE_PERIOD_DATE_LabeL;
    leaseStatusAccordingToCouncilResolutionLabel = ViewApplicationDetailsPlConstants.LEASE_STATUS_ACCORDING_TO_COUNCIL_LabeL;
    lesseeLabel = ViewApplicationDetailsPlConstants.LESSEE_LABEL;
    sellerLabel = ViewApplicationDetailsPlConstants.SELLER_LABEL;
    buyerLabel = ViewApplicationDetailsPlConstants.BUYER_LABEL;
    lesseeTypeTypeLabel = ViewApplicationDetailsPlConstants.LESSEE_TYPE_LABEL;
    alienationLabel = ViewApplicationDetailsPlConstants.ALIENATION_LABEL;
    saleAmountLabel = ViewApplicationDetailsPlConstants.SALE_AMOUNT_LABEL;
    dateofDeedTransferLabel = ViewApplicationDetailsPlConstants.DATE_OF_DEED_TRANSFER_LABEL;
    evaluationAmountLabel = ViewApplicationDetailsPlConstants.EVALUATION_AMOUNT_LABEL;
    acquisitionLabel = ViewApplicationDetailsPlConstants.ACQUISITION_LABEL;
    copyApplicantToLesseeLabel = ViewApplicationDetailsPlConstants.COPY_APPLICANT_TO_LESSEE_LABEL;
    copyApplicantToBuyerLabel = ViewApplicationDetailsPlConstants.COPY_APPLICANT_TO_BUYER_LABEL;
    copyApplicantToSellerLabel = ViewApplicationDetailsPlConstants.COPY_APPLICANT_TO_SELLER_LABEL;
    referenceNumberLabel = ViewApplicationDetailsPlConstants.REFERENCE_NUMBER_LABEL;
    applicationTypes = [];
    leaseTypes = [];
    lesseeTypes = [];
    lesseeDisableFilterBy = true;
    lesseeDisableAdd = false;
    lesseeDisableEditing = false;
    lesseeGroups = [];
    lesseeListLabel = "Lessee";
    buyerDisableFilterBy = true;
    buyerDisableAdd = false;
    buyerDisableEditing = false;
    buyerGroups = [];
    buyerListLabel = "Buyer";
    sellerDisableFilterBy = true;
    sellerDisableAdd = false;
    sellerDisableEditing = false;
    sellerGroups = [];
    sellerListLabel = "Seller";
    transferringAttorneyDisableFilterBy = true;
    transferringAttorneyDisableAdd = true;
    transferringAttorneyDisableEditing = false;
    transferringAttorneyShowFields = true;
    transferringAttorneyIsInternal = false;
    transferringAttorneyGroups = [];
    transferringAttorneyLabel = ViewApplicationDetailsPlConstants.TRANSFERRING_ATTORNEY_LABEL;
    transferringAttorneyFormControlName = ViewApplicationDetailsPlConstants.TRANSFERRING_ATTORNEY_FORM_CONTROL_NAME;
    leaseAreaDrawn = false;
    application;
    getApplicationSaveDetailsObservable;
    getStepMetaObservableSubscription;
    detailsFormGroupName = "detailsForm";
    constructor(aflaModuleStrategyService, route, routerParamsService, recipientListService, recipientSelectService, appController, datePipe, viewApplicationService, propertyAndLeaseService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.datePipe = datePipe;
        this.viewApplicationService = viewApplicationService;
        this.propertyAndLeaseService = propertyAndLeaseService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    onBtnCopyApplicantToLesseeClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const lesseeFormControl = this.detailsForm.get(this.lesseeFormControlName);
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, lesseeFormControl, true);
    }
    onBtnCopyApplicantToBuyerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const buyerFormControl = this.detailsForm.get(this.buyerFormControlName);
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, buyerFormControl, true);
    }
    onBtnCopyApplicantToSellerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const sellerFormControl = this.detailsForm.get("sellerRecipient");
        this.changeDetectorRefs.detectChanges();
        this.recipientListService.addRecipient(applicant, true, sellerFormControl, true);
    }
    applicationTypeChanged() {
        const applicationType = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get("applicationType").value.value;
        if (applicationType === "Lease") {
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseTypeFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseReasonFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeTypeFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseUseFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseRentalAgreementFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStartDateFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseEndDateFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractNumberFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseAccountNumberFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseCommentsFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractEscalationFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leasePeriodFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseNoticePeriodFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStatusAccordingToCouncilResolutionFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountAlienationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedAlienationTransferFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountAlienationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.buyerFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedTransferFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.sellerFormControlName).disable();
        }
        else if (applicationType === "Alienation") {
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountAlienationFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedAlienationTransferFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountAlienationFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.buyerFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseTypeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseReasonFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeTypeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseUseFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseRentalAgreementFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStartDateFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseEndDateFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractNumberFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseAccountNumberFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseCommentsFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractEscalationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leasePeriodFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseNoticePeriodFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStatusAccordingToCouncilResolutionFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedTransferFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.sellerFormControlName).disable();
        }
        else if (applicationType === "Acquisition") {
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedTransferFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.sellerFormControlName).enable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseTypeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseReasonFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeTypeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseUseFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseRentalAgreementFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStartDateFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseEndDateFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractNumberFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseAccountNumberFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseCommentsFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseContractEscalationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leasePeriodFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseNoticePeriodFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.leaseStatusAccordingToCouncilResolutionFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.lesseeFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.saleAmountAlienationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.dateofDeedAlienationTransferFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.evaluationAmountAlienationFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.buyerFormControlName).disable();
        }
    }
    getApplication() {
        const params = {
            $expand: `transferAttorney($expand=groups),LeaseAreas,applicant($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            if (this.application.applicationType === "Lease") {
                const lessees = this.detailsForm.get(this.lesseeFormControlName).value.recipients;
                lessees.forEach((lessee) => {
                    lessee = RecipientUtils.removeRecipientProperties(lessee);
                });
                if (lessees.length === 0) {
                    this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
                }
                this.application.leaseType = this.detailsForm.get(this.leaseTypeFormControlName).value.value;
                this.application.leaseReason = this.detailsForm.get(this.leaseReasonFormControlName).value;
                this.application.leaseUse = this.detailsForm.get(this.leaseUseFormControlName).value;
                this.application.leaseRentalAgreementAmount = this.detailsForm.get(this.leaseRentalAgreementFormControlName).value;
                this.application.leaseStartDate = this.detailsForm.get(this.leaseStartDateFormControlName).value;
                this.application.leaseEndDate = this.detailsForm.get(this.leaseEndDateFormControlName).value;
                this.application.leaseContractNumber = this.detailsForm.get(this.leaseContractNumberFormControlName).value;
                this.application.leaseAccountNumber = this.detailsForm.get(this.leaseAccountNumberFormControlName).value;
                this.application.leaseComments = this.detailsForm.get(this.leaseCommentsFormControlName).value;
                this.application.leaseContractEscalation = this.detailsForm.get(this.leaseContractEscalationFormControlName).value;
                this.application.leasePeriod = this.detailsForm.get(this.leasePeriodFormControlName).value;
                this.application.leaseNoticePeriod = this.detailsForm.get(this.leaseNoticePeriodFormControlName).value;
                this.application.leaseStatusAccordingToCouncilResolution = this.detailsForm.get(this.leaseStatusAccordingToCouncilResolutionFormControlName).value;
                this.application.leaseLesseeType = this.detailsForm.get(this.lesseeTypeFormControlName).value.value;
                this.application.lessees = lessees;
            }
            else if (this.application.applicationType === "Alienation") {
                const transferringAttorneyValue = this.detailsForm.get("transferringAttorneyRecipient").value;
                const transferringAttorney = RecipientUtils.removeRecipientProperties(transferringAttorneyValue);
                this.application.transferAttorney = [transferringAttorney];
                const buyers = this.detailsForm.get(this.buyerFormControlName).value.recipients;
                buyers.forEach((buyer) => {
                    buyer = RecipientUtils.removeRecipientProperties(buyer);
                });
                if (buyers.length === 0) {
                    this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
                }
                this.application.saleAmount = this.detailsForm.get(this.saleAmountAlienationFormControlName).value;
                this.application.dateOfDeedTransfer = this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).value;
                this.application.evaluationAmount = this.detailsForm.get(this.evaluationAmountAlienationFormControlName).value;
                this.application.buyers = buyers;
            }
            else if (this.application.applicationType === "Acquisition") {
                const transferringAttorneyValue = this.detailsForm.get("transferringAttorneyRecipient").value;
                const transferringAttorney = RecipientUtils.removeRecipientProperties(transferringAttorneyValue);
                this.application.transferAttorney = [transferringAttorney];
                const sellers = this.detailsForm.get(this.sellerFormControlName).value.recipients;
                sellers.forEach((seller) => {
                    seller = RecipientUtils.removeRecipientProperties(seller);
                });
                if (sellers.length === 0) {
                    this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
                }
                this.application.saleAmount = this.detailsForm.get(this.saleAmountFormControlName).value;
                this.application.dateOfDeedTransfer = this.detailsForm.get(this.dateofDeedTransferFormControlName).value;
                this.application.evaluationAmount = this.detailsForm.get(this.evaluationAmountFormControlName).value;
                this.application.sellers = sellers;
            }
            const params = {
                application: this.application
            };
            this.getApplicationSaveDetailsObservable =
                this.propertyAndLeaseService.getApplicationSaveDetailsObservable(this.application.id, params)
                    .subscribe({
                    next: appSaveresponse => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName);
        this.detailsForm = form;
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.lesseeGroups = this.recipientSelectService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
            this.buyerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
            this.sellerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
            this.transferringAttorneyGroups = this.recipientSelectService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
            this.applicationTypes = defaults.propertyLeaseApplicationType;
            this.leaseTypes = defaults.leaseTypes;
            this.lesseeTypes = defaults.lesseeTypes;
            this.getApplication();
        }
        else {
            this.lesseeGroups = stepMeta.lesseeGroup;
            if (this.lesseeGroups[0].hasOwnProperty("requiredFields") && this.lesseeGroups[0].requiredFields !== null) {
                this.lesseeGroups = this.recipientListService.checkStepMetaRecipientGroups(this.lesseeGroups);
            }
            this.buyerGroups = stepMeta.buyerGroup;
            if (this.buyerGroups[0].hasOwnProperty("requiredFields") && this.buyerGroups[0].requiredFields !== null) {
                this.buyerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.buyerGroups);
            }
            this.sellerGroups = stepMeta.sellerGroup;
            if (this.sellerGroups[0].hasOwnProperty("requiredFields") && this.sellerGroups[0].requiredFields !== null) {
                this.sellerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.sellerGroups);
            }
            this.transferringAttorneyGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.attorneyGroup);
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
                this.leaseTypes = this.aflaModuleStrategyService.lookups.get("leaseTypes");
                this.lesseeTypes = this.aflaModuleStrategyService.lookups.get("lesseeTypes");
                this.getApplication();
            }
            else {
                this.getLookups();
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType' or name eq 'LeaseType' or name eq 'LesseeType')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const leaseTypes = [];
        const lesseeTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LeaseType") {
                    leaseTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LesseeType") {
                    lesseeTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.aflaModuleStrategyService.lookups.set("leaseTypes", leaseTypes);
        this.leaseTypes = leaseTypes;
        this.aflaModuleStrategyService.lookups.set("lesseeTypes", lesseeTypes);
        this.lesseeTypes = lesseeTypes;
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.detailsForm.get(this.descriptionFormControlName).setValue(this.application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(this.application.referenceNumber);
            this.applicationTypes.forEach(item => {
                if (item.value === this.application.applicationType) {
                    this.detailsForm.get(this.applicationTypeFormControlName).setValue(item);
                }
            });
            this.applicationTypeChanged();
            if (this.application.applicationType === "Lease") {
                this.detailsForm.get(this.leaseReasonFormControlName).setValue(this.application.leaseReason);
                this.detailsForm.get(this.leaseUseFormControlName).setValue(this.application.leaseUse);
                this.detailsForm.get(this.leaseRentalAgreementFormControlName).setValue(this.application.leaseRentalAgreementAmount);
                this.detailsForm.get(this.leaseStartDateFormControlName).setValue(this.datePipe.transform(this.application.leaseStartDate, "yyyy-MM-dd"));
                this.detailsForm.get(this.leaseEndDateFormControlName).setValue(this.datePipe.transform(this.application.leaseEndDate, "yyyy-MM-dd"));
                this.detailsForm.get(this.leaseContractNumberFormControlName).setValue(this.application.leaseContractNumber);
                this.detailsForm.get(this.leaseAccountNumberFormControlName).setValue(this.application.leaseAccountNumber);
                this.detailsForm.get(this.leaseCommentsFormControlName).setValue(this.application.leaseComments);
                this.detailsForm.get(this.leaseContractEscalationFormControlName).setValue(this.application.leaseContractEscalation);
                this.detailsForm.get(this.leasePeriodFormControlName).setValue(this.application.leasePeriod);
                this.detailsForm.get(this.leaseNoticePeriodFormControlName).setValue(this.application.leaseNoticePeriod);
                this.detailsForm.get(this.leaseStatusAccordingToCouncilResolutionFormControlName).setValue(this.application.leaseStatusAccordingToCouncilResolution);
                this.detailsForm.get(this.leaseNoticePeriodFormControlName).disable();
                this.detailsForm.get(this.leaseStatusAccordingToCouncilResolutionFormControlName).disable();
                this.leaseTypes.forEach(item => {
                    if (item.value === this.application.leaseType) {
                        this.detailsForm.get(this.leaseTypeFormControlName).setValue(item);
                    }
                });
                this.lesseeTypes.forEach(item => {
                    if (item.value === this.application.leaseLesseeType) {
                        this.detailsForm.get(this.lesseeTypeFormControlName).setValue(item);
                    }
                });
                if (this.application.leaseAreas.length > 0) {
                    this.leaseAreaDrawn = true;
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.leaseAreas[0].shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    this.aflaModuleStrategyService.form.get("propertiesForm").get("leaseArea").setValue(geom);
                }
                this.getLessees();
            }
            else if (this.application.applicationType === "Alienation") {
                this.detailsForm.get(this.saleAmountAlienationFormControlName).setValue(this.application.saleAmount);
                this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).setValue(this.datePipe.transform(this.application.dateOfDeedTransfer, "yyyy-MM-dd"));
                this.detailsForm.get(this.evaluationAmountAlienationFormControlName).setValue(this.application.evaluationAmount);
                this.changeDetectorRefs.detectChanges();
                const transferringAttorneyControl = this.detailsForm.get(this.transferringAttorneyFormControlName);
                if (this.application.transferAttorney.length > 0) {
                    const transferringAttorney = this.application.transferAttorney[0];
                    this.recipientSelectService.setRecipient(transferringAttorney, false, transferringAttorneyControl);
                }
                else {
                    transferringAttorneyControl.disable();
                }
                this.getBuyers();
            }
            else if (this.application.applicationType === "Acquisition") {
                this.detailsForm.get(this.saleAmountFormControlName).setValue(this.application.saleAmount);
                this.detailsForm.get(this.dateofDeedTransferFormControlName).setValue(this.datePipe.transform(this.application.dateOfDeedTransfer, "yyyy-MM-dd"));
                this.detailsForm.get(this.evaluationAmountFormControlName).setValue(this.application.evaluationAmount);
                this.changeDetectorRefs.detectChanges();
                const transferringAttorneyControl = this.detailsForm.get(this.transferringAttorneyFormControlName);
                if (this.application.transferAttorney.length > 0) {
                    const transferringAttorney = this.application.transferAttorney[0];
                    this.recipientSelectService.setRecipient(transferringAttorney, false, transferringAttorneyControl);
                    transferringAttorneyControl.enable();
                }
                else {
                    transferringAttorneyControl.disable();
                }
                this.getSellers();
            }
            this.detailsForm.get(this.leaseReasonFormControlName).setValue(this.application.leaseReason);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            this.detailsForm.get(this.applicationTypeFormControlName).disable();
            this.changeDetectorRefs.detectChanges();
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(this.application.applicant[0]);
            this.changeDetectorRefs.detectChanges();
        }
    }
    getLessees() {
        this.propertyAndLeaseService
            .getLesseesObservable(this.jobID)
            .subscribe((response) => this.onGetLesseesCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLesseesCompleted(response) {
        if (response && response.value.length > 0) {
            const lesseeControl = this.detailsForm.get(this.lesseeFormControlName);
            this.recipientListService.setRecipients(response.value, false, lesseeControl);
            this.changeDetectorRefs.detectChanges();
        }
    }
    getSellers() {
        this.propertyAndLeaseService
            .getSellersObservable(this.jobID)
            .subscribe((response) => this.onGetSellersCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetSellersCompleted(response) {
        if (response && response.value.length > 0) {
            const sellerControl = this.detailsForm.get(this.sellerFormControlName);
            this.recipientListService.setRecipients(response.value, false, sellerControl);
            this.changeDetectorRefs.detectChanges();
        }
    }
    getBuyers() {
        this.propertyAndLeaseService
            .getBuyersObservable(this.jobID)
            .subscribe((response) => this.onGetBuyersCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetBuyersCompleted(response) {
        if (response && response.value.length > 0) {
            const buyerControl = this.detailsForm.get(this.buyerFormControlName);
            this.recipientListService.setRecipients(response.value, false, buyerControl);
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: ViewApplicationService },
        { type: PropertyAndLeaseService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsPlComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-pl",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsPlComponent);
export { ViewApplicationDetailsPlComponent };
